import AccountSettings from '../components/account-settings/account-settings'
import Booking from '../components/bookings/booking'
import OverView from '../components/overview/overview'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import Nexts from '../components/nexts/next'
import Afters from '../components/afters/after'
import Forall from '../components/forall/all'
import Loading from 'vue-loading-overlay'
// import { VueDatePicker } from '@mathieustan/vue-datepicker'
import DatePick from 'vue-date-pick'
import '@mathieustan/vue-datepicker/dist/vue-datepicker.min.css'

export default {
  AccountSettings,
  Booking,
  OverView,
  VueCtkDateTimePicker,
  Nexts,
  Afters,
  Forall,
  Loading,
  DatePick
}



// WEBPACK FOOTER //
// ./src/app/dweller/profile/me/resources/components.js